import { render } from "./GenericCrudComponent.vue?vue&type=template&id=2624c714&ts=true"
import script from "./GenericCrudComponent.vue?vue&type=script&lang=ts"
export * from "./GenericCrudComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__